var BaseActions = /** @class */ (function () {
    function BaseActions(_a) {
        var siteStore = _a.siteStore, origin = _a.origin;
        this.origin = origin;
        this.siteStore = siteStore;
    }
    return BaseActions;
}());
export { BaseActions };
//# sourceMappingURL=BaseActions.js.map